module.exports = __webpack_public_path__ + "img/logo-orange.90bd9f04.svg";